export enum CouponTypes {
    CorrectScore = 'CorrectScore',
    GoalScorer = 'GoalScorer',
    DailyFavourites = 'DailyFavourites',
    HowManyGoals = 'HowManyGoals',
    InPlayNextGoal = 'InPlayNextGoal',
    SecondUpInstantWin = 'SecondUpInstantWin',
}
